import classNames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { Tooltip } from '@eika/tooltip';

import { ComparisonTableHeader } from './ComparisonTableHeader';
import { ComparisonTableDesktopProps } from './ComparisonTableTypes';

import './ComparisonTableDesktop.scss';

const ComparisonTableRow = (
    props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableRowElement>, HTMLTableRowElement>,
) => <tr className={classNames('sgw-comparison-table__table-row', props.className)}>{props.children}</tr>;

function arrayWithNElements(n: number) {
    return Array(n).fill(0);
}

export const ComparisonTableDesktop = ({
    firstColumnHeader,
    tableHeadColumns,
    rows,
    compact,
    numberOfStarsBasedOnFootnotesIndex,
}: ComparisonTableDesktopProps) => {
    const singleDekning = tableHeadColumns.length === 1;
    return (
        <>
            <table
                className={classNames('sgw-comparison-table', 'sgw-comparison-table-desktop', [
                    { 'sgw-comparison-table--compact': compact },
                ])}
            >
                {!singleDekning && (
                    <thead>
                        <tr>
                            <th>{firstColumnHeader}</th>
                            {tableHeadColumns.map((tableHeadColumn) => (
                                <ComparisonTableHeader
                                    key={
                                        tableHeadColumn.description
                                            ? `${tableHeadColumn.title}-${tableHeadColumn.description.substring(0, 5)}`
                                            : tableHeadColumn.title
                                    }
                                    title={tableHeadColumn.title}
                                    description={tableHeadColumn.description}
                                    color={tableHeadColumn.color}
                                    recommendationLabel={tableHeadColumn.recommendationLabel}
                                />
                            ))}
                        </tr>
                    </thead>
                )}
                <tbody>
                    {rows.map((row) => (
                        <ComparisonTableRow key={row.title}>
                            <th scope="row" className="sgw-comparison-table__table-cell">
                                <div className="sgw-comparison-table__table-cell--vertical-center">
                                    {singleDekning && (
                                        <Icon
                                            wrapperClassName="sgw-comparison-table__checkmark sgw-comparison-table__checkmark--single-dekning"
                                            type={IconTypes.CHECKMARK_TIL_SIRKEL_24}
                                        />
                                    )}
                                    <span className="sgw-comparison-table__table-cell-title">
                                        {row.title}
                                        {row.titleFootnote && numberOfStarsBasedOnFootnotesIndex(row.titleFootnote)}
                                    </span>
                                    {row.help && <Tooltip title={row.title}>{row.help}</Tooltip>}
                                </div>
                            </th>
                            {!singleDekning &&
                                arrayWithNElements(row.checkedRows).map((_, index) => (
                                    <td
                                        className="sgw-comparison-table__table-cell sgw-comparison-table__table-cell--centered"
                                        key={row.title + tableHeadColumns[index].title}
                                    >
                                        {!row.hideCheckmark && (
                                            <>
                                                <Icon
                                                    wrapperClassName="sgw-comparison-table__checkmark"
                                                    type={IconTypes.CHECKMARK_TIL_SIRKEL_24}
                                                />
                                                <p className="screen-reader-text">Inkludert</p>
                                            </>
                                        )}
                                        {row.subTexts && (
                                            <p className="sgw-comparison-table__table-cell-subtext">
                                                {row.subTexts[index].text}
                                                {row.subTexts[index].footnote &&
                                                    numberOfStarsBasedOnFootnotesIndex(row.subTexts[index].footnote)}
                                            </p>
                                        )}
                                    </td>
                                ))}
                            {arrayWithNElements(tableHeadColumns.length - row.checkedRows).map((_, index) => (
                                <td
                                    className="sgw-comparison-table__table-cell sgw-comparison-table__table-cell--centered"
                                    key={row.title + tableHeadColumns[tableHeadColumns.length - index - 1].title}
                                >
                                    <p className="screen-reader-text">Ikke inkludert</p>
                                </td>
                            ))}
                        </ComparisonTableRow>
                    ))}
                </tbody>
            </table>
        </>
    );
};
